import React from 'react'
import FormInputGroup from '../UI/FormInputGroup'
import { Widget, WidgetContent, Divider, TextField, Button } from '@duik/it'
import CloseIcon from '@material-ui/icons/ClearRounded'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
// import cls from '../styles/Header.scss'

const ChangePassword = props => {
  return (
    <Widget>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h3 style={{ margin: '25px' }}>Change Password</h3>
        <CloseIcon onClick={() => props.setProfileScreen('edit')} className="closeIcon" />
      </div>

      <Divider />
      <Formik
        initialValues={{
          password: '',
          passwordNew1: '',
          passwordNew2: ''
        }}
        validationSchema={ProfileSchema}
        handleSubmit={e => console.log(e)}
        onSubmit={values => {
          // createNewContact(values)
          console.log(values)
        }}
        render={({ values, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
          <form>
            <WidgetContent style={{ height: '386px' }}>
              <FormInputGroup horizontal>
                <div>
                  <TextField
                    className="fullWidthInputBox"
                    label="PASSWORD"
                    name="password"
                    type="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // value={values.password}
                  />
                  <ErrorMessage
                    name="password"
                    render={msg => (
                      <span
                        style={{
                          position: 'absolute',
                          color: '#E6492D',
                          fontSize: '0.75rem'
                        }}
                      >
                        {msg}
                      </span>
                    )}
                  />
                </div>
              </FormInputGroup>
              <FormInputGroup horizontal>
                <div style={{ paddingTop: '10px' }}>
                  <TextField
                    className="fullWidthInputBox"
                    label="New Password"
                    name="passwordNew1"
                    type="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.passwordNew1}
                  />
                  <ErrorMessage
                    name="passwordNew1"
                    render={msg => (
                      <span
                        style={{
                          position: 'absolute',
                          color: '#E6492D',
                          fontSize: '0.75rem'
                        }}
                      >
                        {msg}
                      </span>
                    )}
                  />
                </div>
              </FormInputGroup>
              <FormInputGroup horizontal>
                <div style={{ paddingTop: '10px' }}>
                  <TextField
                    className="fullWidthInputBox"
                    label="Confirm New Password"
                    name="passwordNew2"
                    type="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.passwordNew2}
                  />
                  <ErrorMessage
                    name="passwordNew2"
                    render={msg => (
                      <span
                        style={{
                          position: 'absolute',
                          color: '#E6492D',
                          fontSize: '0.75rem'
                        }}
                      >
                        {msg}
                      </span>
                    )}
                  />
                </div>
              </FormInputGroup>
            </WidgetContent>

            <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button onClick={() => props.setProfileScreen('edit')}>Cancel</Button>
              <Button onClick={() => console.log('save')}>OK</Button>
            </WidgetContent>
          </form>
        )}
      />
    </Widget>
  )
}

export default ChangePassword

const ProfileSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'Min 6 characters')
    .max(10, 'Too Long!')
    .required('Required'),
  passwordNew1: Yup.string()
    .min(6, 'Min 6 characters')
    .max(15, 'Max 15 characters')
    .required('Required'),
  passwordNew2: Yup.string()
    .min(6, 'Min 6 characters')
    .max(15, 'Max 15 characters')
    .required('Required')
    .oneOf([Yup.ref('passwordNew1'), null], "Passwords don't match")
})
